module.exports = __webpack_public_path__ + "css/OffgridEnergy.6b69cb16.css";